export const getCurrentSubmitProgress = (
  hasFile: boolean,
  isSubmitting: boolean,
  submitDone: boolean,
  fileUploadProgress?: number
): 'UPLOADING' | 'UPLOAD_DONE' | 'PROCESSING' | 'SUBMITTING' | 'SUBMITTED' | 'UNKNOWN' => {
  if (isSubmitting) {
    return 'SUBMITTING'
  }
  if (submitDone) {
    return 'SUBMITTED'
  }
  if (hasFile) {
    if (typeof fileUploadProgress === 'number' && fileUploadProgress < 100) {
      return 'UPLOADING'
    }
    if (typeof fileUploadProgress === 'undefined') {
      return 'UPLOAD_DONE'
    }
    return 'PROCESSING'
  }
  return 'UNKNOWN'
}
